import { Box, Flex } from 'components/elements'
import { ShimmerCss } from './ListShimmer'
import { ButtonShimmer } from './ButtonShimmer'

export const InteractiveVideoShimmer = () => {
  return (
    <Flex direction={'column'} css={{ width: '100%' }}>
      <Box
        css={{
          ...ShimmerCss,
          width: '100%',
          height: 500,
          borderRadius: '$space$8',
        }}
      />
      <Flex align={'center'} justify={'between'} css={{ mt: '$space$25' }}>
        <ButtonShimmer />
        <ButtonShimmer />
      </Flex>
    </Flex>
  )
}

export const ThreeSixtyShimmer = () => {
  return (
    <>
      {/* <Flex direction={'column'} css={{ mb: '$space$30' }}>
        <Box css={{ ...ShimmerCss, ...TitleCss, mb: '$space$2' }}></Box>
        <Box css={{ ...ShimmerCss, ...SubTitleCss }}></Box>
        <Box
          css={{ ...ShimmerCss, ...TitleCss, mb: '$space$2', mt: '$space$20' }}
        ></Box>
        <Box css={{ ...ShimmerCss, ...SubTitleCss }}></Box>
      </Flex> 
      <Box css={{ ...ShimmerCss, ...TitleCss, my: '$space$20' }}></Box>
      <Box
        css={{ height: 1, mb: '$space$30', background: '$borderDark' }}
      ></Box>*/}
      <Flex direction={'column'} align={'center'} justify={'center'}>
        <Flex css={{ py: '$space$5', pb: '$space$30' }}>
          {[...Array(3)].map((_, index) => (
            <ButtonShimmer key={index} />
          ))}
        </Flex>
        <InteractiveVideoShimmer />
      </Flex>
    </>
  )
}

// const TitleCss = {
//   width: 120,
//   height: 20,
// }
// const SubTitleCss = {
//   width: 250,
//   height: 20,
// }
